import { useLocation, useParams, useSearchParams } from 'react-router-dom';

import type { Id } from '../api/types';
import { useQltTimetableStore } from '../stores/qlt';
import { periodLabel, resolvePeriodLabels } from './periodLabels';

export interface BoardNavigationState {
  classTitle?: string;
  subjectTitle?: string;
  lessonTitle?: string;
  topicLessonId?: string;
  classNoteId?: Id;
  subjectId?: Id;
  gradeId?: Id;
  courseId?: string;
  /** Set when the teacher deliberately chose Bảng trắng - see useClearUnit. */
  blankBoard?: boolean;
}

export interface BoardContextValue extends BoardNavigationState {
  /** Always resolved; '' when neither route state nor the timetable names it. */
  classTitle: string;
  subjectTitle: string;
  date: string;
  index: number;
  classId: string;
  unitId: string | null;
  /** "Tiết 3-4" for a merged block; per-period data still keys on index. */
  periodLabel: string;
}

export function useBoardContext(): BoardContextValue {
  const params = useParams();
  const [search] = useSearchParams();
  const location = useLocation();
  const state = (location.state || {}) as BoardNavigationState;
  const cells = useQltTimetableStore((store) => store.todayCells);
  const date = params.date || '';
  const index = Number(params.index) || 0;
  const classId = params.classId || '';
  // a board loaded by URL has no route state; its timetable cell still names the subject and class
  const labels = resolvePeriodLabels(state, cells, { date, index, classId });
  return {
    date,
    index,
    classId,
    unitId: search.get('unit'),
    periodLabel: periodLabel(cells, { date, index, classId }),
    classTitle: labels.classTitle,
    subjectTitle: labels.subjectTitle,
    lessonTitle: state.lessonTitle,
    topicLessonId: state.topicLessonId,
    classNoteId: state.classNoteId,
    subjectId: state.subjectId,
    gradeId: state.gradeId,
    courseId: state.courseId,
    blankBoard: state.blankBoard,
  };
}
